import { Component, Input } from '@angular/core';
import { ApiService } from '@shared/apis';
import { Constants } from '@shared/constants/constants';

@Component({
  selector: 'app-dp-progress',
  templateUrl: './dp-progress.component.html',
  styleUrls: ['./dp-progress.component.scss']
})
export class DpProgressComponent {

  statusName: any;
  rate: any = 0;

  readonly statusList = {
    ZS01: {
      ST005: 1,
      ST010: 10,
      ST015: 33,
      ST025: 75,
      ST030: 50,
      ST033: 1,
      ST035: 100,
      ST040: 100,
      ST050: 1,
      ST051: 1,
      ST052: 1,
    },
    ZR01: {
      E0001: 1,
      E0002: 100,
      E0003: 1,
      E0004: 100,
    },
    ZS01_DET002: {
      ES005: 10,
      ES010: 20,
      ES015: 40,
      ES020: 50,
      ES025: 60,
      ES030_IN_TRANSIT: 80,
      ES030_DELIVERED: 90,
      ES030_COMPLETE: 100,
      ES040: 100,
      ES080: 1,
      ES090: 1,
      REJECTED: 1,
    }
  };
  _statusName: any;

  constructor(private apiService: ApiService) {
  }

  _status: any;

  get status() {
    return this._status;
  }

  @Input()
  set status(value) {
    this._status = value;
    this.setStatusName();
  }

  _processType: any;

  get processType() {
    return this._processType;
  }

  @Input()
  set processType(value) {
    this._processType = value;
  }

  @Input()
  set isFull(value) {
    this.setStatusName(value);
  }

  @Input()
  set name(value) {
    this._statusName = value;
  }

  setStatusName(isFull = false) {
    if (!this.status || !this.processType) {
      return;
    }

    this.rate = this.statusList[this.processType][this.status];

    // this.rate = Math.floor((Math.random() * 100));
    if (this.rate > 0) {
      if (this._statusName) {
        this.statusName = this._statusName;
      } else {
        this.statusName = Constants.gcicStatusCodeForProgress[this.status];
      }
      // this.statusName = this.status;
      // if (isFull) {
      //   this.apiService.master.getStatus(Configs.defaultDetailType)
      //     .subscribe(res => {
      //       this.statusName = `${this.status} ${res[this.status].name}`;
      //     });
      // }
    }
  }

}
